import React from 'react';
import "./index.css";


function StateButton(props){
		return (
			<div style={{ ...props.style }}>
				<div className="lds-ellipsis">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
		);
}


export { StateButton }
